import type { SVGProps } from 'react';
const SvgSimCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#sim_card_svg__a)">
      <path
        fill="currentColor"
        d="M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16ZM9 19H7v-2h2v2Zm8 0h-2v-2h2v2Zm-8-4H7v-4h2v4Zm4 4h-2v-4h2v4Zm0-6h-2v-2h2v2Zm4 2h-2v-4h2v4Z"
      />
    </g>
    <defs>
      <clipPath id="sim_card_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSimCard;
